export const clean = (obj: Record<string, any>): Record<string, any> => {
  Object.keys(obj).forEach((key) => {
    const value = obj[key];
    if (value === undefined || value === null || value === "") {
      delete obj[key];
    } else if (Array.isArray(value) && value.length === 0) {
      delete obj[key];
    } else if (value && typeof value === "object") {
      // Skip Firestore Timestamps and Dates - don't recursively clean them
      if (value.constructor?.name === "Timestamp" || value instanceof Date || typeof value.toDate === "function") {
        return;
      }
      // Skip arrays (already handled above for empty arrays)
      if (Array.isArray(value)) {
        return;
      }
      // Recursively clean plain objects
      clean(value);
    }
  });
  return obj;
};
